import { render, staticRenderFns } from "./CarListAdd.vue?vue&type=template&id=edc8d622&scoped=true"
import script from "./CarListAdd.vue?vue&type=script&lang=js"
export * from "./CarListAdd.vue?vue&type=script&lang=js"
import style0 from "./CarListAdd.vue?vue&type=style&index=0&id=edc8d622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc8d622",
  null
  
)

export default component.exports